import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import EndView from "../views/EndView.vue";
import WaitView from "../views/WaitView.vue";
import Gain1View from "../views/Gain1View.vue";
import Gain2View from "../views/Gain2View.vue";
import Gain3View from "../views/Gain3View.vue";
import MentionsLegalesView from "../views/MentionsLegalesView.vue";
import NotFoundView from "../views/NotFoundView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/mentions-legales",
    name: "mentions-legales",
    component: MentionsLegalesView,
  },
  {
    path: "/form",
    name: "form",
    component: () => import("../views/FormView.vue"),
  },
  {
    path: "/status/:_id/:uid",
    name: "status",
    component: () => import("../views/StatusView.vue"),
  },
  {
    path: "/end",
    name: "end",
    component: EndView,
  },
  {
    path: "/wait",
    name: "wait",
    component: WaitView,
  },
  {
    path: "/bravo-maillot",
    name: "gain1",
    component: Gain1View,
  },
  {
    path: "/bravo-tasse",
    name: "gain2",
    component: Gain2View,
  },
  {
    path: "/bravo-code-promo",
    name: "gain3",
    component: Gain3View,
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContactView.vue"),
  },
  {
    path: "*",
    name: "not-found",
    component: NotFoundView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Configuration de l'opération
const OPERATION_START_DATE = new Date("2026-02-01T00:00:00");
const OPERATION_END_DATE = new Date("2026-04-06T23:59:59");
const STATUS_PAGE_END_DATE = new Date("2026-04-15T23:59:59");
const PROD_DOMAIN = "cartenoire-graindepassion.fr";

// Pages accessibles même hors période d'opération
const ALLOWED_PAGES_OUTSIDE_OPERATION = ["wait", "end", "mentions-legales", "contact"];

// Navigation guard pour rediriger si hors période d'opération sur le domaine de prod
router.beforeEach((to, from, next) => {
  const currentDate = new Date();
  const isProdDomain = window.location.hostname === PROD_DOMAIN;
  const isOperationNotStarted = currentDate < OPERATION_START_DATE;
  const isOperationEnded = currentDate > OPERATION_END_DATE;
  const isStatusPageStillAccessible = currentDate <= STATUS_PAGE_END_DATE;
  const isAllowedPage = ALLOWED_PAGES_OUTSIDE_OPERATION.includes(to.name);

  // Page status accessible jusqu'au 15 avril
  const isStatusPage = to.name === "status";
  if (isStatusPage && isStatusPageStillAccessible && isProdDomain) {
    next();
    return;
  }

  // Si on est sur le domaine de prod ET on n'est pas sur une page autorisée
  if (isProdDomain && !isAllowedPage) {
    if (isOperationNotStarted) {
      // Opération pas encore commencée → redirection vers /wait
      next({ name: "wait" });
    } else if (isOperationEnded) {
      // Opération terminée → redirection vers /end
      next({ name: "end" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
